interface ControlAPPConstantInt {
    API_URL: string
    CONTROLBOXEX_API_URL: string
    URL_WITHOUT_TOKEN: Array<string>
    URL_LOGO_APP: string
    URL_LOGO_APP_NAME: string
    TOKEN_NAME: string
	TU_COMPRA_TERMINAL: string
}

export const CONTROL_APP_CONST: ControlAPPConstantInt = {
    API_URL: "https://clientestest.controlboxexpress.com/api/",
    CONTROLBOXEX_API_URL: "https://pruebas.controlboxexpress.com/api/",
    URL_WITHOUT_TOKEN: [],
    URL_LOGO_APP: 'assets/images/logo_app.png',
    URL_LOGO_APP_NAME: 'assets/images/logo_app.png',
    TOKEN_NAME: 'access_token',
	TU_COMPRA_TERMINAL: 'egb011bd75q8pyz9',
};



// WEBPACK FOOTER //
// ./src/app/control-app/config/control-app.constant.ts